"use client";

import { create } from "zustand";
import { ReactNode } from "react";

// Define the Message type
interface Message {
  text: ReactNode;
  severity: "error" | "warning" | "info" | "success";
}

// Define the store type
interface AlertStore {
  message: Message | null;
  setMessage: (message: Message | null) => void;
}

// Create the Zustand store
export const useAlertStore = create<AlertStore>((set) => ({
  message: null,
  setMessage: (message) => set({ message }),
}));
